import dynamic from 'next/dynamic';
import { ReslinkEventDetailsProps } from './ReslinkEventDetails.types';
import { ReslinkEventDetails as ReslinkEventDetailsBauStatic } from './ReslinkEventDetails';
import { ReslinkEventDetailsDtt as ReslinkEventDetailsDttStatic } from './ReslinkEventDetailsDtt';

export const ReslinkEventDetailsBauDynamic = dynamic<{ model: ReslinkEventDetailsProps }>(() =>
  import('./ReslinkEventDetails').then(mod => mod.ReslinkEventDetails)
);

const ReslinkEventDetailsDttDynamic = dynamic<{ model: ReslinkEventDetailsProps }>(() =>
  import('./ReslinkEventDetailsDtt').then(mod => mod.ReslinkEventDetailsDtt)
);

export const ReslinkEventDetails =
  (isAuthorMode: boolean, isDtt: boolean) => (props: { model: ReslinkEventDetailsProps }) => {
    if (isAuthorMode) {
      return isDtt ? <ReslinkEventDetailsDttStatic {...props} /> : <ReslinkEventDetailsBauStatic {...props} />;
    }
    return isDtt ? <ReslinkEventDetailsDttDynamic {...props} /> : <ReslinkEventDetailsBauDynamic {...props} />;
  };
